"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContactClearStore = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.addContactClearStore = (0, toolkit_1.createAction)('ADD_CONTACT/CLEAR_STORE');
